<div *ngIf="paymentData" class="container">
  <div class="payment-header">
    <button
      mat-button
      color="primary"
      (click)="backButton()"
      class="back-button"
    >
      <img src="/assets/images/icons/left-arrow.svg" alt="" />
    </button>
    <h1 class="page-title">Complete Purchase</h1>
  </div>
  <div class="flex-co">
    <div class="payment-section">
      <div class="box-container">
        <div class="section-header">
          <h3 class="section-title">1. Delivery Method:</h3>
        </div>
        <div class="delivery-form">
          <div class="input-label">Email:</div>
          <input
            class="delivery-input"
            placeholder="Enter Email"
            [(ngModel)]="deliveryMethod"
            id="email-input"
          />
        </div>
      </div>

      <div class="box-container fill">
        <div class="section-header">
          <h3 class="section-title">2. Payment Method:</h3>
        </div>
        <div class="list-co">
          <mat-radio-group
            class="radio-group mb"
            [formControl]="wallet"
            (click)="checkWallet()"
          >
            <div class="option-container">
              <div class="image-co">
                <img
                  class="image-card"
                  src="assets/images/icons/wallet-gray.svg"
                />
                <h2 class="item-title">Wallet</h2>
              </div>
              <div class="inline-container">
                <p
                  class="remaining"
                  *ngIf="
                    (wallet.value && !isInsufficient) ||
                    (isInsufficient && remaining > 0)
                  "
                  [ngClass]="{ 'red-color': isInsufficient }"
                >
                  {{ storeDetail?.currency_detail?.symbol }}{{ remaining }}
                </p>
                <mat-radio-button
                  [disabled]="isInsufficient"
                  (click)="resetGateways()"
                  class="radio-button"
                  [value]="wallet"
                ></mat-radio-button>
              </div>
            </div>
          </mat-radio-group>
          <mat-radio-group
            class="radio-group"
            [formControl]="gateway"
            *ngIf="gatewayList?.length > 0"
          >
            <ng-container *ngFor="let gatewayItem of gatewayList">
              <ng-container *ngIf="gatewayItem.can_use_for_purchase">
                <div class="option-container">
                  <div class="image-co">
                    <img class="image-card" [src]="gatewayItem?.logo" />
                    <h2 class="item-title">{{ gatewayItem?.title }}</h2>
                  </div>
                  <mat-radio-button
                    (click)="resetWallet()"
                    class="radio-button"
                    [value]="gatewayItem"
                  ></mat-radio-button>
                </div>
              </ng-container>
            </ng-container>
          </mat-radio-group>
        </div>
      </div>
    </div>
    <div class="order-summary">
      <div class="login-overlay" *ngIf="!isLoggedIn">
        <div class="overlay-context">
          <p>Please Log In To Your Account To Finalize Your Order.</p>
          <button
            mat-button
            class="custom-full-button secondary"
            (click)="handleLogin()"
          >
            Login
          </button>
        </div>
      </div>
      <div class="section-header">
        <h3 class="section-title">3. Order Summary</h3>
      </div>
      <div class="item-card">
        <div class="context-co">
          <img
            class="image-card"
            defaultImage="assets/images/cards/ic_placeholder.png"
            [lazyLoad]="paymentData.product.logo"
          />
          <h2 class="item-title">
            {{ paymentData.product.name }}
          </h2>
        </div>
        <div class="actions-co">
          <div class="action">
            <img
              src="assets/images/icons/minus-icon.svg"
              alt=""
              (click)="decreaseQuantity()"
            />
          </div>
          <div class="status">{{ paymentData.order.orderCount }}</div>
          <div class="action">
            <img
              src="assets/images/icons/green-plus-icon.svg"
              alt=""
              (click)="increaseQuantity()"
            />
          </div>
        </div>
      </div>
      <div class="payment-info">
        <div class="info-item">
          <div class="item-title">Price:</div>
          <div class="item-value">
            <ng-container *ngIf="paymentData.product.discount > 0">
              {{ paymentData.currency.symbol }}
              {{ paymentData.order.exchangedPrice | convertPrice }}
            </ng-container>
            <ng-container *ngIf="paymentData.product.discount <= 0">
              {{ paymentData.currency.symbol }}
              {{
                paymentData.order.exchangedPrice -
                  (paymentData.product.discount / 100) *
                    paymentData.order.exchangedPrice | convertPrice
              }}
            </ng-container>
          </div>
        </div>
        <div class="info-item">
          <div class="item-title">Quantity:</div>
          <div class="item-value">x {{ paymentData.order.orderCount }}</div>
        </div>
        <div class="info-item">
          <div class="item-title">
            Discount(
            <ng-container *ngIf="paymentData.product.discount > 0">
              {{ paymentData.product.discount | convertPrice }}%
            </ng-container>
            <ng-container *ngIf="paymentData.product.discount <= 0">
              0%
            </ng-container>

            ):
          </div>
          <div class="item-value">
            <ng-container *ngIf="paymentData.product.discount > 0">
              {{ paymentData.currency.symbol
              }}{{
                (paymentData.product.discount / 100) *
                  (paymentData.order.exchangedPrice *
                    paymentData.order.orderCount) | convertPrice
              }}
            </ng-container>
            <ng-container *ngIf="paymentData.product.discount <= 0">
              {{ paymentData.currency.symbol }}0
            </ng-container>
          </div>
        </div>
        <div class="info-item">
          <div class="item-title">Total Amount:</div>
          <div class="item-value">
            {{ paymentData.currency.symbol
            }}{{
              paymentData.order.exchangedPrice * paymentData.order.orderCount -
                (paymentData.product.discount / 100) *
                  (paymentData.order.exchangedPrice *
                    paymentData.order.orderCount) | convertPrice
            }}
          </div>
        </div>

        <div class="info-item" *ngIf="processingFee">
          <div class="item-title">Processing Fee:</div>
          <div class="item-value">
            {{ processingFee | convertPrice }}{{ paymentData.currency.symbol }}
          </div>
        </div>
        <div class="info-item" *ngIf="!isInsufficient && wallet.value">
          <div class="item-title">Wallet:</div>
          <div class="item-value negative-value">
            -{{ paymentData.order.payablePrice | convertPrice
            }}{{ paymentData.currency.symbol }}
          </div>
        </div>
      </div>
      <div class="dashed-border-container">
        <div class="item-title">Payable Amount:</div>
        <div class="item-value">
          {{ paymentData.currency.symbol
          }}{{ paymentData.order.payablePrice | convertPrice }}
        </div>
      </div>
      <div class="fixed-action-co">
        <div class="action-context">
          <div class="action-title">Payable Amount:</div>
          <div class="action-value">
            {{ paymentData.currency.symbol
            }}{{ paymentData.order.payablePrice | convertPrice }}
          </div>
        </div>
        <ng-container *ngIf="isLoggedIn">
          <button
            mat-button
            class="custom-full-button"
            [disabled]="
              (this.gateway.invalid && this.wallet.invalid) ||
              (this.wallet.dirty && this.isInsufficient) ||
              !deliveryMethod
            "
            (click)="submitPayment()"
          >
            Buy Now
          </button>
        </ng-container>
        <ng-container *ngIf="!isLoggedIn">
          <button
            mat-button
            class="custom-full-button secondary"
            (click)="handleLogin()"
          >
            Login
          </button>
        </ng-container>
      </div>
    </div>
  </div>
</div>

<ng-container *ngIf="!paymentData">
  <div class="empty-context-container">
    <div class="image-container">
      <img src="/assets/images/icons/empty-card.png" alt="empty card" />
    </div>
    <p class="empty-title">Your cart is empty !</p>
    <a mat-raised-button mat-dialog-close [routerLink]="['/']"
      >Return to home</a
    >
  </div>
</ng-container>
